import React, { useState } from 'react';
import { Box, Typography, Select, MenuItem } from '@mui/material';
import ColorPickerPopover from './ColorPickerPopover';

const FONT_FAMILIES = ['Inter', 'Roboto', 'Open Sans', 'Georgia', 'monospace'];

const PagePanel = ({ styles = {}, onChange }) => {
  const [anchor, setAnchor] = useState(null);
  const bg = styles.backgroundColor || '#ffffff';

  return (
    <Box>
      <Typography variant="caption" sx={{ color: '#aaa', fontSize: 10, display: 'block', mb: 1.5 }}>
        No element selected — page settings
      </Typography>

      {/* Background */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="caption" sx={{ color: '#888', fontSize: 11, width: 56 }}>
          Background
        </Typography>
        <Box
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{
            width: 24, height: 24, borderRadius: 1,
            background: bg,
            border: '1px solid #ddd',
            cursor: 'pointer',
          }}
        />
        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: 12 }}>{bg}</Typography>
        <ColorPickerPopover
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={() => setAnchor(null)}
          value={bg}
          onChange={(c) => { onChange('backgroundColor', c); setAnchor(null); }}
        />
      </Box>

      {/* Font */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="caption" sx={{ color: '#888', fontSize: 11, width: 56 }}>
          Font
        </Typography>
        <Select
          size="small"
          value={styles.fontFamily || 'Inter'}
          onChange={(e) => onChange('fontFamily', e.target.value)}
          sx={{ fontSize: 12, flex: 1, '& .MuiSelect-select': { py: 0.5 } }}
        >
          {FONT_FAMILIES.map((f) => (
            <MenuItem key={f} value={f} sx={{ fontSize: 12, fontFamily: f }}>{f}</MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default PagePanel;
